import React, { useState, useCallback } from 'react';
import { useSelector } from 'react-redux';
import { FormattedMessage } from 'react-intl';

import { Button } from 'ui-components/components/button';
import messages from '../../../messages';
import style from '../../../../../components/grid-header/reusable-grid-button.module.less';
import { deactivateProducts } from '../../../../../store/products/products.api';
import DeactivateProductModal from './deactivate-product-modal';
import Global from '../../../../../store/global-selectors';

import { useProductContext } from '../../../products/product-context';
import { ProductDetailsService } from '../../../../../services/product-details.service';

const DeactivateButton = () => {
  const { refreshGridData, selectedProductIds } = useProductContext();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const openModal = useCallback(() => setIsModalOpen(true), []);
  const closeModal = useCallback(() => setIsModalOpen(false), []);
  const selectedProducts = useSelector((state) =>
    Global.selectEntitiesProductsByIds(state, {
      productIds: selectedProductIds,
    }),
  );
  const areSomeSelectedIdsInactive = selectedProducts.some((product) => !product.active);
  const deactivateProductCallback = useCallback(() => {
    deactivateProducts(selectedProducts)
      .promise.then(() => {
        refreshGridData();
      })
      .catch((error) => {
        ProductDetailsService.handleProductUpdateErrors(error?.response?.data?.Errors);
      });
    closeModal();
  }, [closeModal, selectedProducts, refreshGridData]);
  return (
    <>
      <Button
        className={style['reusable-button']}
        disabled={selectedProductIds.length === 0 || areSomeSelectedIdsInactive}
        onClick={openModal}
        theme='tertiary'
      >
        <FormattedMessage {...messages.deactivateButton} />
      </Button>
      {isModalOpen && <DeactivateProductModal onClose={closeModal} onConfirm={deactivateProductCallback} />}
    </>
  );
};

export default DeactivateButton;
